<template>
	<div class="app-wrapper" :style="cssVars">
		<div class="sub_wrapper">
			<template v-if="!loading && beforeVotingDay">
				<div class="coming-soon">
					<h2>Voting will begin</h2>
					<h1 style="margin-top: 0.1em">{{ date.toLocaleString() }}</h1>
				</div>
			</template>
			<template v-else-if="!loading && afterVotingDay">
				<div class="coming-soon">
					<h1>Sorry, voting has ended. We appreciate your participation.</h1>
				</div>
			</template>
			<template v-else>
				<div class="loading" v-if="loading"></div>
				<div class="error" v-if="!loading && error">
					There was an error while handling your request.
					<br /><small>({{ error_message }})</small>
				</div>
				<div
					class="error error_with_message"
					v-if="!loading && error_with_message"
				>
					{{ error_message }}
				</div>
				<div class="error alreadyVoted_message" v-if="!loading && alreadyVoted">
					{{ alreadyVoted_message }}
				</div>
				<template v-if="!loading">
					<template
						v-if="businesses.length >= 1 && opinionId && opinionId !== ''"
					>
						<h2>{{ opinionName }}</h2>

						<img v-if="!is_demo" :src="opinionImage" />
						<div v-else class="demo_image_container">
							<img
								class="demo_image"
								src="/wp-content/plugins/wp-opinion-custom-voting-page/src/assets/demo-custom-voting-image.jpg"
							/>
							<img
								class="demo_vote_for_us_badge"
								:src="campaign_vote_for_us_badge_url"
							/>
						</div>

						<p class="rc-custom-voting-nomination-pre-text">
							Please select the categories you would like to vote for and then
							click the Submit Vote button to enter your vote.
						</p>
						<div class="vote_wrapper">
							<div>
								<div class="rc-custom-voting">
									<template v-for="(business, i) in businesses" :key="i">
										<div
											class="inputGroup"
											@click="selectCategory(i)"
											:key="i"
											:ref="'container_option_' + i"
											v-if="business != undefined"
										>
											<input
												class="single_checkbox"
												:data-b="i"
												:data-c="i"
												:ref="'option_' + i"
												:id="'option_' + i"
												:name="'option_' + i"
												type="checkbox"
											/>
											<label :for="'option_' + i">{{
												clean(business.name)
											}}</label>
										</div>
									</template>
								</div>
								<div
									class="rc-custom-voting"
									style="margin-top: 2em"
									v-if="businesses.length > 1"
								>
									<div
										class="inputGroup"
										@click="selectAllCategories(i)"
										:key="i"
										:ref="'container_all_option_' + (businesses.length + 1)"
									>
										<input
											class="single_checkbox"
											:data-b="businesses.length + 1"
											:ref="'all_option_' + (businesses.length + 1)"
											:id="'all_option_' + (businesses.length + 1)"
											:name="'all_option_' + (businesses.length + 1)"
											type="checkbox"
										/>
										<label :for="'all_option_' + (businesses.length + 1)"
											>Select All</label
										>
									</div>
								</div>
							</div>
						</div>
						<div style="margin-top: 10px">
							<button
								@click="submit"
								type="submit"
								class="ballot-button active"
							>
								Submit Vote
							</button>
						</div>
					</template>

					<div class="popup" :class="{ active: success }">
						<button class="close" @click="success = false">
							<i
								class="x-icon x-graphic-child x-graphic-icon x-graphic-primary"
								aria-hidden="true"
								data-x-icon-o=""
							></i>
						</button>
						<p class="vote-success">Thank you! Your votes have been cast.</p>
						<p v-if="message.length > 1" class="popup-paragraph">
							{{ message }}
						</p>
						<a
							v-if="button_text.length > 1 && button_url.length > 1"
							:href="button_url"
							class="review-button"
							>{{ button_text }}</a
						>
						<div class="fail" v-if="votes_failed.length > 0">
							<div class="message">
								Sorry, your vote was not counted for the following subcategories
								because you have already voted today:
								<span
									class="list-item"
									v-for="entry in votes_failed"
									:key="entry.name"
									>{{ entry.name }}</span
								>
							</div>
						</div>
						<ul v-if="voteUrl.length > 1">
							<li>Share with others:</li>
							<li>
								<a :href="facebookUrl" target="_blank"
									><svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 320 512"
									>
										<!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
										<path
											fill="#D0AE2F"
											d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
										/></svg
								></a>
							</li>
							<li>
								<a :href="linkedInUrl" target="_blank"
									><svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 448 512"
									>
										<!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
										<path
											fill="#D0AE2F"
											d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
										/></svg
								></a>
							</li>
							<li>
								<a :href="mailUrl"
									><svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 512 512"
									>
										<!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
										<path
											fill="#D0AE2F"
											d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"
										/></svg
								></a>
							</li>
							<li>
								<a :href="smsUrl"
									><svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 384 512"
									>
										<!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
										<path
											fill="#D0AE2F"
											d="M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zm80 432h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
										/></svg
								></a>
							</li>
							<li>
								<a :href="twitterUrl" target="_blank"
									><svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 512 512"
									>
										<!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc. -->
										<path
											fill="#D0AE2F"
											d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
										/></svg
								></a>
							</li>
							<li>
								<a
									@click.prevent="copyToClipboard()"
									class="copy_to_clipboard_link"
									target="_blank"
									><svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 512 512"
									>
										<!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
										<path
											fill="#D0AE2F"
											d="M502.6 70.63l-61.25-61.25C435.4 3.371 427.2 0 418.7 0H255.1c-35.35 0-64 28.66-64 64l.0195 256C192 355.4 220.7 384 256 384h192c35.2 0 64-28.8 64-64V93.25C512 84.77 508.6 76.63 502.6 70.63zM464 320c0 8.836-7.164 16-16 16H255.1c-8.838 0-16-7.164-16-16L239.1 64.13c0-8.836 7.164-16 16-16h128L384 96c0 17.67 14.33 32 32 32h47.1V320zM272 448c0 8.836-7.164 16-16 16H63.1c-8.838 0-16-7.164-16-16L47.98 192.1c0-8.836 7.164-16 16-16H160V128H63.99c-35.35 0-64 28.65-64 64l.0098 256C.002 483.3 28.66 512 64 512h192c35.2 0 64-28.8 64-64v-32h-47.1L272 448z"
										/></svg
								></a>
							</li>
						</ul>
					</div>
				</template>

				<DoubleVerify
					:active="showValidation"
					@submit="submit"
					@updatevalidationvalues="updateValidationValues"
					:verification_code="verification_code"
					:request_code="request_code"
					:campaignID="campaignID"
				/>
			</template>
		</div>
	</div>
</template>

<script>
import DoubleVerify from './components/DoubleVerify';
import { cvp_get } from './api_cvp';
import { get, post } from './api';

function getOrCreateBrowserId() {
	const key = 'rco_browser_id';
	let id = localStorage.getItem(key);
	if (!id || id === 'undefined' || id === 'null') {
		if (window.crypto && crypto.randomUUID) {
			id = crypto.randomUUID();
		} else {
			id =
				'b_' +
				Math.random().toString(36).slice(2) +
				'_' +
				Date.now().toString(36);
		}
		localStorage.setItem(key, id);
	}
	return id;
}

async function sha256Hex(input) {
	try {
		if (!window.crypto || !crypto.subtle) return null;
		const enc = new TextEncoder().encode(input);
		const buf = await crypto.subtle.digest('SHA-256', enc);
		return Array.from(new Uint8Array(buf))
			.map((b) => b.toString(16).padStart(2, '0'))
			.join('');
	} catch (e) {
		return null;
	}
}

function getAcceptLanguage() {
	const langs =
		navigator.languages && navigator.languages.length
			? navigator.languages.join(',')
			: navigator.language || '';
	return langs || null;
}

function getTimezoneOffsetMinutes() {
	const v = new Date().getTimezoneOffset();
	return Number.isFinite(v) ? v : null;
}

function getReferrer() {
	return document.referrer || null;
}

export default {
	components: {
		DoubleVerify,
	},
	data: () => ({
		step: 1,
		businesses: [],
		hasMultipleBusinesses: false,
		ballot: [],
		chosenCategory: {},
		lastAdded: [],
		error: false,
		error_with_message: false,
		error_message: '',
		success: false,
		success_message: false,
		votes_success: [],
		votes_failed: [],
		show_sms_sharing: false,
		alreadyVoted: false,
		loading: false,
		windowWidth: 0,
		beforeVotingDay: false,
		afterVotingDay: false,
		campaignID: '',
		date: '',
		last_replaced: [],
		replaced: false,
		alreadyVoted_message: '',
		verification_code: '',
		request_code: '',
		showValidation: false,
		is_demo: false,
		primaryColor: '#0F383A',
		secondaryColor: '#E0C835',
		browser_meta: {
			browser_id: null,
			user_agent_hash: null,
			accept_language: null,
			timezone_offset: null,
			referrer: null,
		},
		opinionImage: '',
		campaign_vote_for_us_badge_url: '',
		voteUrl: '',
		share_phone_number: '',
		button_text: '',
		button_url: '',
		message: '',
	}),
	computed: {
		cssVars() {
			return {
				'--primary-color': this.primaryColor,
				'--secondary-color': this.secondaryColor,
			};
		},
		facebookUrl() {
			return 'https://www.facebook.com/sharer.php?u=' + this.voteUrl;
		},
		linkedInUrl() {
			return (
				'https://www.linkedin.com/shareArticle?url=' +
				this.voteUrl +
				'&title=' +
				this.opinionName
			);
		},
		mailUrl() {
			return (
				'mailto:?subject=' + this.opinionName + '&body=Vote: ' + this.voteUrl
			);
		},
		twitterUrl() {
			return (
				'https://twitter.com/share?url=' +
				this.voteUrl +
				'&text=' +
				this.opinionName
			);
		},
		smsUrl() {
			return 'sms:?&body=Vote: ' + this.voteUrl;
		},
	},
	mounted() {
		this.windowWidth = window.innerWidth;
		this.$nextTick(() => {
			window.addEventListener('resize', () => {
				this.windowWidth = window.innerWidth;
			});
		});
	},
	methods: {
		selectCategory(business_index) {
			// const vm = this;
			let ref_name = 'container_option_' + business_index;
			let checkbox_ref_name = 'option_' + business_index;
			const b_length = this.businesses.length + 1;

			// console.log(ref_name);
			// console.log(this.$refs)
			// this.$refs[ref_name][0].classList.add("asdfas");
			// console.log(this.$refs[ref_name][0].classList);
			if (this.$refs[checkbox_ref_name][0].checked == true) {
				this.businesses[business_index].selected = true;
				this.$refs[ref_name][0].classList.add('inputGroup-selected');
			} else {
				this.businesses[business_index].selected = false;
				this.$refs[ref_name][0].classList.remove('inputGroup-selected');
				this.$refs['all_option_' + b_length].checked = false;
			}

			console.log(this.businesses[business_index]);
		},
		selectAllCategories() {
			const vm = this;
			const b_length = this.businesses.length + 1;

			if (this.$refs['all_option_' + b_length].checked) {
				let ref_name = '';
				let checkbox_ref_name = '';
				vm.businesses.forEach(function (business, business_index) {
					ref_name = 'container_option_' + business_index;
					checkbox_ref_name = 'option_' + business_index;
					vm.businesses[business_index].selected = true;
					vm.$refs[ref_name][0].classList.add('inputGroup-selected');
					vm.$refs[checkbox_ref_name][0].checked = true;
				});
			}
		},
		setVerification() {
			const vm = this;
			vm.loading = true;
			vm.error_with_message = false;
			let verificaiton_code = localStorage.getItem('iever_code_hash');
			//   debugger;
			if (
				verificaiton_code == 'undefined' ||
				verificaiton_code == null ||
				verificaiton_code == ''
			) {
				post('verify/create', { campaign_hash: vm.campaignID }).then(
					(data) => {
						vm.loading = false;
						if (data.success == 'true') {
							localStorage.setItem('iever_code_hash', data.code);
							localStorage.setItem(
								'iever_sesh_verify_code',
								data.session_request_temp_code,
							);
							vm.verification_code = data.code;
							vm.request_code = data.session_request_temp_code;
						} else {
							vm.error = true;
							vm.error_message = data.message ?? 'unknown error';
						}
					},
					() => {
						vm.loading = false;
						vm.error = true;
						vm.error_message = 'Error communicating with the server x3450';
					},
				);
			} else {
				post('verify', {
					campaign_hash: vm.campaignID,
					validation_hash: verificaiton_code,
				}).then(
					(data) => {
						vm.loading = false;

						if (data.success == 'true') {
							// console.log(data);
							vm.verification_code = verificaiton_code;
							vm.request_code = data.session_request_temp_code;
							localStorage.setItem(
								'iever_sesh_verify_code',
								data.session_request_temp_code,
							);
						} else if (data.success == 'false') {
							if (data.message == 'Validation missing.') {
								localStorage.removeItem('iever_code_hash');
								localStorage.removeItem('iever_sesh_verify_code');
								vm.error_with_message = true;
								vm.error_message =
									'Your validation has expired. Please refresh the page and try again.';
								console.log('Error verify Response with message');
								console.log(error.response);
								console.log(error.response.data.message);
							}
						} else {
							vm.error = true;
							vm.error_message = 'Error communicating with the server x3451';
						}
					},
					() => {
						vm.loading = false;
						vm.error = true;
						vm.error_message = 'Error communicating with the server x3449';
					},
				);
				//this.verification_code = verificaiton_code;
			}
		},
		updateValidationValues(verificaiton_code, request_code) {
			const vm = this;
			// debugger;
			vm.verification_code = verificaiton_code;
			vm.request_code = request_code;
			localStorage.setItem('iever_code_hash', vm.verification_code);
			localStorage.setItem('iever_sesh_verify_code', vm.request_code);
			console.log('Updated codes on parent:');
			console.log(vm.verification_code);
			console.log(vm.request_code);
		},
		clean(str) {
			if (str !== undefined) {
				let newstr = str.replace(/&amp;/g, '&');
				newstr = newstr.replace(/&apos;/g, "'");
				return newstr;
			}
		},
		linkTo(link) {
			if (link != null && link != '') {
				window.open(link, '_blank');
			}
		},
		submit() {
			const vm = this;

			let ballot = [];

			// debugger;

			if (is_demo === 1) {
				vm.success = true;
				vm.success_message = 'Thank you! Your votes have been cast.';
				// vm.step = 4;

				return true;
			}

			vm.businesses.forEach(function (business, business_index) {
				if (business.selected) {
					ballot.push({
						name: business.name,
						opinion_id: vm.opinionId,
					});
				}
			});
			vm.ballot = ballot;
			// debugger;

			vm.showValidation = false;
			// debugger;
			if (vm.ballot.length > 0) {
				vm.loading = true;
				vm.error = false;
				vm.error_with_message = false;
				vm.error_message = '';

				let _already_voted_ = false;
				let _already_voted_for_category = '';
				let _already_voted_for_name = '';
				for (let i = 0; i < vm.ballot.length; i++) {
					let _key_ = 'rcopinion-voted-opb-' + vm.ballot[i].id;
					if (
						new Date().toISOString().substring(0, 10) ===
						localStorage.getItem(_key_)
					) {
						_already_voted_ = true;
						_already_voted_for_category = vm.ballot[i].name;
						_already_voted_for_name = vm.ballot[i].name;
						// debugger;
						break;
					}
				}

				_already_voted_ = false;

				// check if user already voted today from localstorage
				if (_already_voted_) {
					vm.loading = false;
					vm.alreadyVoted = true;
					// debugger;
					vm.alreadyVoted_message =
						'Sorry, you have already voted for the category ' +
						vm.clean(_already_voted_for_category) +
						' for ' +
						vm.clean(_already_voted_for_name) +
						'. Please uncheck that category and try again.';
					//post('novote', {ballot: vm.ballot});
				} else {
					// debugger;
					post('vote', {
						ballot: vm.ballot,
						campaign: vm.campaignID,
						source: 'custom',
						validation_code: vm.verification_code,
						request_code: vm.request_code,
						browser_id: vm.browser_meta.browser_id,
						user_agent_hash: vm.browser_meta.user_agent_hash,
						accept_language: vm.browser_meta.accept_language,
						timezone_offset: vm.browser_meta.timezone_offset,
						referrer: vm.browser_meta.referrer,
					}).then(
						(data) => {
							vm.loading = false;

							if (data && data.success) {
								vm.businesses.forEach(function (business, business_index) {
									business.selected = false;
								});

								for (let i = 0; i < vm.ballot.length; i++) {
									let _key_ = 'rcopinion-voted-opb-' + vm.ballot[i].id;
									localStorage.setItem(
										_key_,
										new Date().toISOString().substring(0, 10),
									);
								}

								vm.alreadyVoted = false;
								vm.error = false;

								if (data.approved_votes && data.approved_votes.length > 0) {
									vm.ballot = [];
									vm.chosenCategory = [];
									vm.lastAdded = [];
									vm.success = true;
									vm.success_message = data.success;
									vm.votes_failed = data.unapproved_votes;
									// vm.step = 4;
								} else {
									vm.alreadyVoted_message =
										'Sorry, we were not able to submit your vote because you have already voted today.';
									vm.alreadyVoted = true;
									vm.error_with_message = false;
								}
							} else if (data.vote_ip_limit_hit == 'true') {
								vm.showValidation = true;
							} else if (data.too_many_votes) {
								//Not used anymore
								vm.alreadyVoted = true;
								vm.error_with_message = false;
								// } else if(data.error && data.message != ''){ //Not used anymore
								//     console.log("Post in else after message");
								//     vm.error_with_message = true;
								//     vm.error_message = data.message;
							} else {
								vm.error = true;
								vm.error_message = 'Error communicating with the server x3448';
							}
						},
						(error) => {
							if (
								typeof error.response !== 'undefined' &&
								error.response.data.error &&
								error.response.data.message != ''
							) {
								//Not used anymore

								console.log('Post in else after message');
								if (
									error.response.data.message == 'false' ||
									error.response.data.message == false ||
									error.response.data.message == ''
								) {
									console.log('Empty Error Response');
									console.log(error.response);
								}
								console.log('Error Response with message');
								console.log(error.response);
								console.log(error.response.data.message);
								vm.error_with_message = true;
								vm.error_message = error.response.data.message;
								vm.loading = false;
							} else {
								vm.loading = false;
								vm.error = true;
								vm.error_message = 'Error communicating with the server x3447';
							}
						},
					);
				}
			}
		},
		closeValidationBox() {
			this.showValidation = false;
		},
		copyToClipboard() {
			const textToCopy = this.voteUrl;
			navigator.clipboard.writeText(textToCopy);
			alert('Url Copied');
		},
	},
	beforeMount() {
		const vm = this;
		vm.loading = true;

		(async () => {
			const browser_id = getOrCreateBrowserId();
			const ua = navigator.userAgent || '';
			const user_agent_hash = await sha256Hex(ua);

			vm.browser_meta = {
				browser_id,
				user_agent_hash: user_agent_hash,
				accept_language: getAcceptLanguage(),
				timezone_offset: getTimezoneOffsetMinutes(),
				referrer: getReferrer(),
			};
		})();

		vm.pageHash = eicvpage_hash;
		vm.page = eicvpage;

		vm.opinionId = opinion_id;
		vm.opinionName = opinion_name;

		if (typeof primary_color != 'undefined') {
			vm.primaryColor = primary_color;
		}
		if (typeof secondary_color != 'undefined') {
			vm.secondaryColor = secondary_color;
		}

		vm.is_demo = is_demo;

		if (is_demo === 1) {
			vm.loading = false;
			vm.businesses = [
				{ name: 'Burger' },
				{ name: 'Lunch Spot' },
				{ name: 'Great Eats' },
				{ name: 'Salad' },
			];
			vm.beforeVotingDay = false;
			vm.afterVotingDay = false;
			vm.campaign_vote_for_us_badge_url = campaign_vote_for_us_badge_url;

			vm.message = `We appreciate your vote, please continue to vote for us every day during the contest. We would also appreciate you visiting our Google listing and give us a review!`;
			vm.button_url = 'https://eliteinsights.io';
			vm.button_text = 'Leave us a review';
			vm.voteUrl = window.location.href;
		} else {
			cvp_get('get/' + vm.pageHash).then(
				(data) => {
					vm.loading = false;
					if (data.success) {
						vm.campaignID = data.success.campaign_hash;
						vm.opinionHash = data.success.opinion_hash;
						vm.opinionImage = data.success.image;

						if (data.success.button_text) {
							vm.button_text = data.success.button_text;
						}

						if (data.success.button_url) {
							vm.button_url = data.success.button_url;
						}

						if (data.success.message) {
							vm.message = data.success.message;
						}

						cvp_get('getshorturl/' + vm.campaignID).then((data) => {
							if (data.success) {
								vm.voteUrl = data.success.short_url_domain + '/' + vm.page;
							}
						});

						var categories = JSON.parse(data.success.categories);
						vm.setVerification();

						for (let n = 0; n < categories.length; n++) {
							var obj = {
								name: categories[n],
							};

							vm.businesses.push(obj);
						}

						get('vdate/' + vm.campaignID).then(
							(data) => {
								vm.loading = false;

								if (data.success) {
									vm.date = new Date(data.voting_date_ts * 1000);
									let votingStart = new Date(data.time * 1000);
									let votingEnd = new Date(data.endtime * 1000);
									let today = new Date(data.today * 1000);
									let over = window.location.search;

									if (over != '?testshow' && is_demo != 1) {
										if (today < votingStart) {
											vm.beforeVotingDay = true;
										}

										if (today > votingEnd) {
											vm.afterVotingDay = true;
										}
									}
								} else {
									vm.error = true;
								}
							},
							() => {
								vm.loading = false;
								vm.error = true;
							},
						);
					} else {
						vm.error = true;
					}
				},
				() => {
					vm.loading = false;
					vm.error = true;
				},
			);
		}
	},
};
</script>

<style>
.demo_image_container {
	position: relative;
}
.demo_vote_for_us_badge {
	position: absolute;
	width: 20%;
	bottom: 2%;
	right: 2%;
}
.app-wrapper h2 {
	text-align: center;
	font-size: 2em;
}
.popup {
	text-align: center;
	max-width: 90%;
	background-color: white;
	box-shadow: -1px 2px 8px 0px rgb(0 0 0 / 45%);
	-webkit-box-shadow: -1px 2px 8px 0px rgb(0 0 0 / 45%);
	-moz-box-shadow: -1px 2px 8px 0px rgba(0, 0, 0, 0.45);
	border-radius: 15px;
	padding: 4px 10px 28px;
	margin: 2em auto 2em;
	z-index: 900;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	display: none;
}
.popup.active {
	display: inherit;
	position: fixed;
	top: 20%;
}
.close {
	margin-right: 0em;
}
.popup .close i.x-icon {
	color: #848484;
	font-size: 1.4em;
}
p.vote-success {
	font-size: 1.3em;
	font-weight: bold;
	color: #000;
	background-color: #b1e6b1;
	padding: 7px 20px;
	margin-bottom: 1em;
	margin-top: 2em;
}
p.popup-paragraph {
	color: #000;
	line-height: 1.6;
}
.popup ul {
	list-style: none;
	margin: 0;
	margin-top: 1em;
	color: #000;
}
.popup ul li {
	display: inline-block;
	padding: 5px;
	font-size: 17px;
}
.popup svg {
	height: 18px;
}
.popup i.x-icon {
	color: #d0ae2f;
}
.popup .review-button {
	background-color: var(--primary-color);
	color: #fff;
	border: none;
	padding: 7px 40px;
	display: inline-block;
}
.app-wrapper {
	background: #fff;
	margin: 0 auto;
	width: 100%;
	padding: 2em;
	position: relative;
}
.loading-wrapper {
	display: block;
	width: 100%;
	height: 100%;
}
.rc-custom-voting {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: flex-start;
}
.coming-soon {
	text-align: center;
	margin-top: 50px;
}
.sub_wrapper {
	width: 100%;
	max-width: 1000px;
	margin: 0 auto;
}

.vote_wrapper {
	display: block;
	width: 100%;
	padding: 2em 0;
}

.fail {
	background: #e97b86;
	border: solid 0.5px #b56068;
	color: #fff;
	margin: 1em 0;
	text-align: center;
}
.fail .message {
	margin-bottom: 0.5em;
	font-weight: 600;
	font-size: 1em !important;
}

.fail .message .list-item ~ .list-item::before {
	content: ', ';
}
.fail .message .list-item ~ .list-item:last-child::before {
	content: ', and ';
}

.inputGroup {
	background-color: #e9ecef;
	display: block;
	margin: 0px 10px 10px 0;
	position: relative;
	border: solid 2px transparent;
}
.inputGroup .business-ad {
	max-width: 210px;
}
.inputGroup-selected {
	border: 2px solid var(--secondary-color);
}
.inputGroup-selected .business-ad {
	max-width: 210px !important;
	position: relative !important;
	left: -2px !important;
}
.inputGroup label {
	padding: 12px 30px 12px 65px;
	display: flex;
	flex-direction: row;
	align-items: center;
	text-align: left;
	color: #000000;
	cursor: pointer;
	position: relative;
	z-index: 2;
	transition: color 200ms ease-in;
	overflow: hidden;
	height: 72px;
	font-size: initial;
	margin: 0;
	line-height: 1em;
}
.inputGroup label:before {
	width: 30px;
	height: 10px;
	border-radius: 50%;
	content: '';
	background-color: #e9ecef;
	position: absolute;
	left: 50%;
	top: 50%;
	transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
	opacity: 0;
	z-index: -1;
}
.inputGroup label:after {
	width: 25px;
	height: 25px;
	content: '';
	border: 2px solid #000;
	background-color: #fff;
	background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.414 11L4 12.414l5.414 5.414L20.828 6.414 19.414 5l-10 10z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E ");
	background-repeat: no-repeat;
	background-position: -1px -1px;
	z-index: 2;
	position: absolute;
	left: 20px;
	top: 50%;
	transform: translateY(-50%);
	cursor: pointer;
	transition: all 200ms ease-in;
}
.inputGroup input:checked ~ label {
	color: #000000;
}
.inputGroup input:checked ~ label:before {
	transform: translate(-50%, -50%) scale3d(31, 31, 1);
	opacity: 1;
}
.inputGroup input:checked ~ label:after {
	background-color: var(--primary-color);
	border-color: var(--primary-color);
}
.inputGroup input {
	width: 32px;
	height: 32px;
	order: 1;
	z-index: 2;
	position: absolute;
	right: 30px;
	top: 50%;
	transform: translateY(-50%);
	cursor: pointer;
	visibility: hidden;
}
.inputGroup-selected > input,
.inputGroup-selected > label,
.inputGroup-selected > img {
	z-index: 1;
	opacity: 0.8;
}
.inputGroup-selected {
	border: 2px solid var(--secondary-color);
}
.ballot-button {
	width: 100%;
	text-align: center;
	padding: 15px !important;
	font-size: 20px !important;
	border-radius: 4px;
	margin-top: 30px;
	letter-spacing: 0.5px;
	cursor: pointer;
}
.ballot-button.active {
	background-color: var(--primary-color);
	color: #fff;
}
.error {
	background: #f6bebe;
	color: #000;
	font-size: 15px;
	padding: 8px 10px;
	margin-bottom: 10px;
	border: 1px solid #ed6161;
}
.success {
	background: #bef6c5;
	color: #000;
	font-size: 18px;
	padding: 15px 10px 18px;
	margin-bottom: 10px;
	width: 100%;
	text-align: center;
	font-weight: 600;
}
@media only screen and (min-width: 600px) {
	.popup {
		padding: 4px 76px 28px;
	}
	.close {
		margin-right: -3em;
	}
}
@media only screen and (max-width: 768px) {
	.inputGroup {
		width: 85% !important;
		min-width: 210px;
		margin: 1em auto;
	}
}
@media only screen and (min-width: 768px) {
	.popup {
		max-width: 510px;
	}
	.app-wrapper h2 {
		text-align: left;
		font-size: 2em;
	}
}
@media screen and (min-width: 900px) {
	.ballot-button {
		width: 25%;
	}
}
@media only screen and (min-width: 992px) {
	.popup {
		padding: 4px 76px 28px;
	}
}
@media only screen and (max-width: 1024px) {
	.success,
	.error {
		font-size: 19px;
		width: 90%;
		text-align: center;
	}
}
@media only screen and (min-width: 1200px) {
}
@media screen and (min-width: 1280px) {
	.inputGroup {
		flex-basis: 30%;
	}
}
</style>
